module.exports = "/_next/static/images/Vehicle-Outfitting-2ad2e380e7bcee23806f12576b67f23d.jpg";